import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { Badge } from '../Badge';
import { ProductCardTypography } from '../ProductCardTypography';
const DEFAULT_YEAR = new Date().getFullYear();
type Props = {
  award: string;
  year?: number;
};
export function ProductCardsRoundupBanner(t0) {
  const $ = _c(9);
  const {
    award,
    year: t1
  } = t0;
  const year = t1 === undefined ? DEFAULT_YEAR : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      "--boa-product-card-icon-height": "56px",
      "--boa-product-card-icon-width": "44.8px",
      minHeight: "var(--boa-product-card-icon-height)"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      position: "relative",
      display: "flex",
      width: "fit-content",
      "--boa-gap-between-elements": "1rem",
      backgroundColor: "greens.lightest"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Badge height="56" width="44.8" style={{
      position: "absolute",
      left: 0,
      top: 0,
      flexShrink: 0
    }} />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      alignItems: "center",
      marginLeft: "var(--boa-product-card-icon-width)",
      position: "relative",
      minHeight: {
        xs: "1.5rem",
        sm: "2.5rem"
      },
      height: "fit-content",
      paddingLeft: 3,
      paddingRight: "var(--boa-gap-between-elements)",
      borderRadius: 1,
      paddingY: 1
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== year) {
    t6 = year.toString();
    $[4] = year;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== award || $[7] !== t6) {
    t7 = <Box sx={t2}><Box sx={t3}>{t4}<Box sx={t5}><ProductCardTypography component="h2">{t6} {award}</ProductCardTypography></Box></Box></Box>;
    $[6] = award;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}